module.exports = __webpack_public_path__ + "img/kdLogo_EN.ab8abdb9.svg";